import * as React from 'react'
import { Well } from '@pushly/aqe/lib/components/index'
import { FeedPath } from '@pushly/models/lib/structs/feeds/feed-path'
import { Feed } from '@pushly/models/lib/structs/feeds/feed'
import { FeedPathPropertyInput } from '@halo/portals/post-auth/domains/feeds/feed-path-property-input'
import { FeedType } from '@pushly/models/lib/enums/feed-type'

interface IFPPEWProps {
    workingModel: Feed
    setWorkingModel: React.Dispatch<Feed>
    onChange: (properties: FeedPath) => void
    type: FeedType.JSON | FeedType.XML
}

export const FeedPathPropertyExpressionsWell = (props: IFPPEWProps) => {
    const { workingModel, setWorkingModel, type } = props

    const isJson = type === FeedType.JSON

    const propertiesDescriptor = isJson ? 'JSONPath' : 'XPath'
    const propertiesPath = isJson ? 'feedJsonpath' : 'feedXpath'

    return (
        <>
            <Well title={`${propertiesDescriptor} Expressions`} hideFooter={true}>
                <FeedPathPropertyInput
                    property="articles"
                    labelText="Articles"
                    tooltipText={`Provide the ${propertiesDescriptor} expression that refers to the list of articles within the feed.`}
                    placeholder={isJson ? '[*]' : '/channel/item'}
                    value={workingModel.config[propertiesPath].articles ?? undefined}
                    onChange={(next) => {
                        const update = workingModel.toMutable()
                        update.config[propertiesPath].articles = next

                        setWorkingModel(update)
                    }}
                />
                <FeedPathPropertyInput
                    property="url"
                    labelText="Article URL"
                    placeholder={isJson ? '`this`.link' : 'string(.//link/text())'}
                    value={workingModel.config[propertiesPath].properties.url ?? undefined}
                    onChange={(next) => {
                        const update = workingModel.toMutable()
                        update.config[propertiesPath].properties.url = next

                        setWorkingModel(update)
                    }}
                />
                <FeedPathPropertyInput
                    property="id"
                    labelText="Article ID"
                    tooltipText="If the feed does not have an Article ID use the URL expression for this value"
                    placeholder={isJson ? '`this`.id' : 'string(.//guid/text())'}
                    value={workingModel.config[propertiesPath].properties.id ?? undefined}
                    onChange={(v) => {
                        const update = workingModel.toMutable()
                        update.config[propertiesPath].properties.id = v

                        setWorkingModel(update)
                    }}
                />
                <FeedPathPropertyInput
                    property="title"
                    labelText="Title"
                    placeholder={isJson ? '`this`.title' : 'string(.//title/text())'}
                    value={workingModel.config[propertiesPath].properties.title ?? undefined}
                    onChange={(v) => {
                        const update = workingModel.toMutable()
                        update.config[propertiesPath].properties.title = v

                        setWorkingModel(update)
                    }}
                />
                <FeedPathPropertyInput
                    property="body"
                    labelText="Body"
                    placeholder={isJson ? '`this`.description' : 'string(.//description/text())'}
                    disabled={!workingModel.config.fieldOptions.body.enabled}
                    value={workingModel.config[propertiesPath].properties.body ?? undefined}
                    onChange={(v) => {
                        const update = workingModel.toMutable()
                        update.config[propertiesPath].properties.body = v

                        setWorkingModel(update)
                    }}
                />
                <FeedPathPropertyInput
                    property="image"
                    labelText="Image URL"
                    placeholder={isJson ? '`this`.image' : 'string(.//link/text())'}
                    disabled={!workingModel.config.fieldOptions.image.enabled}
                    value={workingModel.config[propertiesPath].properties.image ?? undefined}
                    onChange={(v) => {
                        const update = workingModel.toMutable()
                        update.config[propertiesPath].properties.image = v

                        setWorkingModel(update)
                    }}
                />
                <FeedPathPropertyInput
                    property="keywords"
                    labelText="Keywords"
                    placeholder={isJson ? '`this`.keywords' : './/keywords/text()'}
                    disabled={!workingModel.config.fieldOptions.keywords.enabled}
                    value={workingModel.config[propertiesPath].properties.keywords ?? undefined}
                    onChange={(v) => {
                        const update = workingModel.toMutable()
                        update.config[propertiesPath].properties.keywords = v

                        setWorkingModel(update)
                    }}
                />
                <FeedPathPropertyInput
                    property="publishedDate"
                    labelText="Publish Date"
                    tooltipText="Leave this field blank if the feed does not have a publish date"
                    placeholder={isJson ? '`this`.pub_date' : 'string(.//pubDate/text())'}
                    value={workingModel.config[propertiesPath].properties.publishedDate ?? undefined}
                    onChange={(v) => {
                        const update = workingModel.toMutable()
                        update.config[propertiesPath].properties.publishedDate = v

                        setWorkingModel(update)
                    }}
                />
            </Well>
        </>
    )
}
